import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section className="contact" id="contact">
      <h2>İletişim</h2>

      {/* KARTVİZİTLER */}
      <div className="contact-cards">
        <div className="contact-card">
          <h3>Mustafa Katar</h3>
          <span>Müteahhit&Mühendis</span>
          <a href="tel:05325927745">0532 592 77 45</a>
        </div>

        
        <div className="contact-card">
          <h3>Şaban Katar</h3>
          <span>Müteahhit</span>
          <a href="tel:05327314918">0532 731 49 18</a>
        </div>

        <div className="contact-card">
          <h3>Serbay Katar</h3>
          <span>Mimar</span>
          <a href="tel:05399753047">0539 975 30 47</a>
        </div>

        <div className="contact-card">
          <h3>Gölbay Katar</h3>
          <span>Mühendis</span>
          <a href="tel:05322712274">0532 271 22 74</a>
        </div>

        <div className="contact-card">
          <h3>Yücel Katar</h3>
          <span>Mimar</span>
          <a href="tel:05325137367">0532 513 73 67</a>
        </div>
      </div>

      {/* OFİSLER */}
      <div className="contact-offices">

        {/* 1. OFİS */}
        <div className="office">
          <h3>Merkez Ofis</h3>
          <p>Mahmut Moralı Sk. No:15/1 A Blok Zuhuratbaba Mh. / Bakırköy</p>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1505.9670753545286!2d28.87044272767855!3d40.98292272817904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cabca8a6e34c21%3A0x3814985b8e0eeca9!2zWnVodXJhdGJhYmEsIE1haG11dCBNb3JhbMSxIFNrLiBObzoxNiwgMzQxNDcgQmFrxLFya8OeS_EsHN0YW5idWw!5e0!3m2!1str!2str!4v1776930442698!5m2!1str!2str"
            width="100%"
            height="300"
            style={{ border: 0 }}
            loading="lazy"
            title="Merkez Ofis"
          ></iframe>
        </div>

        {/* 2. OFİS */}
        <div className="office">
          <h3>Şube Ofis</h3>
          <p>Zeki Müren Sk. No:5/4 Şirinevler Mh. / Bahçelievler</p>

          <iframe
            src="https://www.google.com/maps?q=40.99648829236893,28.84996083020235&output=embed"
            width="100%"
            height="300"
            style={{ border: 0 }}
            loading="lazy"
            title="Şube Ofis"
          ></iframe>
        </div>

      </div>
    </section>
  );
};

export default Contact;